import { Box, Button, FormControl, MenuItem, Modal, Select, Stack, Typography, IconButton } from '@mui/material';
import { MultiSelect } from "react-multi-select-component";
import dayjs from 'dayjs';
import DateRangeModal from '../modals/DateRangeModal';
import { useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';

const SERVICE_TYPES = [
    { label: 'Tất cả', value: 'all' },
    { label: 'Việt', value: 'viet' },
    { label: 'Hàn', value: 'han' }
];

const FilterModal = ({ 
    open, 
    handleClose, 
    startDate, 
    endDate, 
    setDateRangeModal,
    method,
    setMethod,
    selectedStaffs,
    setSelectedStaffs,
    staffOptions,
    hasPermission,
    authUser,
    serviceGroup,
    setServiceGroup,
    serviceType,
    setServiceType,
    serviceGroups
}) => {
    const [dateRangeModalOpen, setDateRangeModalOpen] = useState(false);

    return (
        <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="filter-modal-title"
        >
            <Box sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: { xs: '95%', sm: '80%', md: '500px' },
                bgcolor: 'background.paper',
                boxShadow: 24,
                borderRadius: 2,
                maxHeight: '90vh',
                overflow: 'hidden',
                display: 'flex',
                flexDirection: 'column'
            }}>
                {/* Header */}
                <Box sx={{ 
                    p: 2, 
                    borderBottom: '1px solid',
                    borderColor: 'divider',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    bgcolor: 'background.paper'
                }}>
                    <Typography variant="h6" component="h2" sx={{ fontWeight: 600 }}>
                        Bộ lọc
                    </Typography>
                    <IconButton 
                        onClick={handleClose}
                        size="small"
                        sx={{ 
                            color: 'text.secondary',
                            '&:hover': {
                                color: 'text.primary',
                                bgcolor: 'action.hover'
                            }
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </Box>

                {/* Content */}
                <Box sx={{ 
                    p: 3,
                    overflow: 'auto',
                    flex: 1,
                    bgcolor: 'background.default'
                }}>
                    <Stack spacing={3}>
                        {/* Date Range */}
                        <Box>
                            <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 1 }}>
                                Thời gian
                            </Typography>
                            <Box 
                                onClick={() => setDateRangeModalOpen(true)}
                                sx={{ 
                                    cursor: 'pointer',
                                    p: 2,
                                    border: '1px solid',
                                    borderColor: 'divider',
                                    borderRadius: 1,
                                    bgcolor: 'background.paper',
                                    transition: 'all 0.2s',
                                    '&:hover': {
                                        borderColor: 'primary.main',
                                        bgcolor: 'action.hover'
                                    }
                                }}
                            >
                                <Typography>
                                    {`${dayjs(startDate).format('DD/MM/YYYY')} - ${dayjs(endDate).format('DD/MM/YYYY')}`}
                                </Typography>
                            </Box>
                        </Box>

                        {/* Service Group */}
                        <Box>
                            <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 1 }}>
                                Nhóm dịch vụ
                            </Typography>
                            <FormControl fullWidth variant='outlined' size="small">
                                <Select 
                                    value={serviceGroup}
                                    onChange={(e) => setServiceGroup(e.target.value)}
                                    displayEmpty
                                    sx={{ bgcolor: 'background.paper' }}
                                >
                                    <MenuItem value={null}>
                                        <Typography color="text.secondary">Tất cả</Typography>
                                    </MenuItem>
                                    {serviceGroups.map((group) => (
                                        <MenuItem key={group.id} value={group.id}>
                                            {group.name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Box>

                        {/* Service Type */}
                        <Box>
                            <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 1 }}>
                                Loại dịch vụ
                            </Typography>
                            <FormControl fullWidth variant='outlined' size="small">
                                <Select 
                                    value={serviceType}
                                    onChange={(e) => setServiceType(e.target.value)}
                                    displayEmpty
                                    sx={{ bgcolor: 'background.paper' }}
                                >
                                    {SERVICE_TYPES.map((type) => (
                                        <MenuItem key={type.value} value={type.value}>
                                            {type.label}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Box>

                        {/* Payment Method */}
                        <Box>
                            <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 1 }}>
                                Hình thức thanh toán
                            </Typography>
                            <FormControl fullWidth variant='outlined' size="small">
                                <Select 
                                    value={method}
                                    onChange={(e) => setMethod(e.target.value)}
                                    displayEmpty
                                    sx={{ bgcolor: 'background.paper' }}
                                >
                                    <MenuItem value={0}>
                                        <Typography color="text.secondary">Tất cả</Typography>
                                    </MenuItem>
                                    {[
                                        { label: 'Ví Anhdior Lotus', id: 1 },
                                        { label: 'Tiền mặt', id: 2 },
                                        { label: 'Chuyển khoản', id: 5 },
                                        { label: 'Quẹt thẻ', id: 6 },
                                    ].map((item) => (
                                        <MenuItem key={item.id} value={item.id}>
                                            {item.label}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Box>

                        {/* Staff Selection */}
                        {hasPermission(authUser, ['view_payment_all', 'write_payment']) && (
                            <Box>
                                <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 1 }}>
                                    Chọn nhân viên
                                </Typography>
                                <Box sx={{ 
                                    border: '1px solid',
                                    borderColor: 'divider',
                                    borderRadius: 1,
                                    p: 1,
                                    bgcolor: 'background.paper'
                                }}>
                                    <MultiSelect
                                        options={staffOptions}
                                        value={selectedStaffs}
                                        onChange={setSelectedStaffs}
                                        labelledBy="Chọn nhân viên"
                                        overrideStrings={{
                                            "allItemsAreSelected": "Tất cả",
                                            "clearSearch": "Xoá",
                                            "clearSelected": "Bỏ chọn",
                                            "search": "Tìm kiếm",
                                            "selectAll": "Chọn tất cả",
                                            "selectAllFiltered": "Chọn tất cả",
                                            "selectSomeItems": "Lựa chọn nhân viên"
                                        }}
                                    />
                                </Box>
                            </Box>
                        )}
                    </Stack>
                </Box>

                {/* Footer */}
                <Box sx={{ 
                    p: 2, 
                    borderTop: '1px solid',
                    borderColor: 'divider',
                    display: 'flex',
                    justifyContent: 'flex-end',
                    gap: 2,
                    bgcolor: 'background.paper'
                }}>
                    <Button 
                        variant="outlined" 
                        onClick={handleClose}
                        fullWidth
                    >
                        Đóng
                    </Button>
                </Box>

                <DateRangeModal
                    open={dateRangeModalOpen}
                    startDate={startDate}
                    endDate={endDate}
                    onConfirm={(range) => {
                        setDateRangeModal(range);
                        setDateRangeModalOpen(false);
                    }}
                    handleClose={() => setDateRangeModalOpen(false)}
                />
            </Box>
        </Modal>
    );
};

export default FilterModal; 